import { render, staticRenderFns } from "./addwck.vue?vue&type=template&id=15176f3f&scoped=true"
import script from "./addwck.vue?vue&type=script&lang=js"
export * from "./addwck.vue?vue&type=script&lang=js"
import style0 from "./addwck.vue?vue&type=style&index=0&id=15176f3f&prod&lang=less&scoped=true"
import style1 from "./addwck.vue?vue&type=style&index=1&id=15176f3f&prod&lang=less"
import style2 from "./addwck.vue?vue&type=style&index=2&id=15176f3f&prod&lang=less"
import style3 from "./addwck.vue?vue&type=style&index=3&id=15176f3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15176f3f",
  null
  
)

export default component.exports